import portre from "../../assets/portre.jpeg";
import baba from "../../assets/baba.jpeg";
import pocak from "../../assets/pocak.jpeg";

const tumbnails = { portre, baba, pocak };

export { tumbnails };
